import {IRoutableModule} from '../../router/routing.infra';
import {DashboardLayout} from './dashboard.view';
import {dashboardRouteLoader} from './dashboard.loader';

export default {
    loader: dashboardRouteLoader,
    Component: DashboardLayout,
    storeAs: 'dashboardStore'
} as IRoutableModule;
